"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get FiltersV3Service () {
        return FiltersV3Service;
    },
    get addDummyRootAndNest () {
        return addDummyRootAndNest;
    }
});
const _common = require("@nestjs/common");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _RowColorCondition = /*#__PURE__*/ _interop_require_default(require("~/models/RowColorCondition"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _filtersservice = require("~/services/filters.service");
const _apiv3datatransformationbuilder = require("~/utils/api-v3-data-transformation.builder");
const _viewwebhookmanager = require("~/utils/view-webhook-manager");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function extractLogicalOp(group_operator) {
    return group_operator == null ? void 0 : group_operator.toLowerCase();
}
function addDummyRootAndNest(filters) {
    // If empty, return undefined
    if (filters.length === 0) {
        return undefined;
    }
    // Create a map of filters by parent_id for easy lookup
    const filterMap = new Map();
    filters.forEach((filter)=>{
        const parentId = filter.parent_id || null;
        if (!filterMap.has(parentId)) {
            filterMap.set(parentId, []);
        }
        filterMap.get(parentId).push(filter);
    });
    // Helper function to determine group_operator for a group
    const getGroupOperatorFromFirstChild = (groupId)=>{
        var _logical_op;
        const children = filterMap.get(groupId) || [];
        return children.length > 0 && children[0].logical_op ? (_logical_op = // since in the current implementation, the first child logical op doesn't matter and it always and
        (children[1] || children[0]).logical_op) == null ? void 0 : _logical_op.toUpperCase() : null;
    };
    // Build a nested structure recursively
    const buildNestedStructure = (parentId)=>{
        const children = filterMap.get(parentId) || [];
        return children.map((child)=>{
            const isGroup = !!child.is_group;
            const groupOperator = isGroup ? getGroupOperatorFromFirstChild(child.id) : undefined;
            const currentItem = _extends({}, child, {
                parent_id: undefined,
                group_operator: isGroup ? groupOperator : undefined,
                logical_op: undefined,
                filters: isGroup ? buildNestedStructure(child.id) : undefined,
                is_group: undefined
            });
            if (!isGroup) {
                delete currentItem.logical_op; // Remove logical_op from non-groups
            }
            return currentItem;
        });
    };
    // Build the nested structure starting from the dummy root
    const nestedFilters = buildNestedStructure(null);
    // Add the dummy root group
    return {
        id: 'root',
        group_operator: nestedFilters.length > 0 ? getGroupOperatorFromFirstChild(null) : null,
        filters: nestedFilters
    };
}
let FiltersV3Service = class FiltersV3Service {
    async filterCreate(context, param) {
        // if root group creation then check existing root group
        await this.insertFilterGroup({
            context,
            param,
            groupOrFilter: param.filter,
            viewId: param.viewId
        });
        const list = this.filterList(context, param);
        return list;
    }
    async insertFilterGroup({ context, param, groupOrFilter, parentId = null, logicalOp = null, isRoot = true, viewId, viewWebhookManager, ncMeta = _Noco.default.ncMeta }) {
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/FilterCreate', groupOrFilter, true, context);
        let currentParentId = parentId;
        const { additionalProps } = await this.extractAdditionalProps(param, context, ncMeta);
        let innerViewWebhookManager;
        if (param.viewId && !viewWebhookManager) {
            const view = await _models.View.get(context, param.viewId, ncMeta);
            innerViewWebhookManager = param.viewId ? (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate() : null;
        } else if (param.rowColorConditionId && !viewWebhookManager) {
            const rowColorCondition = await _RowColorCondition.default.getById(context, param.rowColorConditionId, ncMeta);
            const view = await _models.View.get(context, rowColorCondition.fk_view_id, ncMeta);
            innerViewWebhookManager = (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(rowColorCondition.fk_view_id)).forUpdate();
        }
        // if logicalOp is not provided, extract based on the parent group
        if (!logicalOp) {
            var _this;
            logicalOp = ((_this = await this.extractGroup(context, {
                viewId: viewId,
                parentFilterId: parentId || (groupOrFilter == null ? void 0 : groupOrFilter.parent_id) || 'root'
            }, ncMeta)) == null ? void 0 : _this.group_operator) || 'AND';
        }
        // if not filter group simply insert filter
        if ('field_id' in groupOrFilter && groupOrFilter.field_id) {
            await _models.Filter.insert(context, _extends({}, (0, _apiv3datatransformationbuilder.filterRevBuilder)().build(groupOrFilter), {
                fk_parent_id: parentId === 'root' ? null : parentId
            }, additionalProps, {
                logical_op: extractLogicalOp(logicalOp),
                id: undefined
            }), ncMeta);
            return;
        }
        if (isRoot) {
            // Check if parentId exists within groupOrFilter
            const hasParentInGroup = 'parent_id' in groupOrFilter && groupOrFilter.parent_id;
            if (!hasParentInGroup) {
                // Root group handling when parent_id is not provided in groupOrFilter
                const existingRootFilters = await _models.Filter.rootFilterList(context, {
                    viewId
                }, ncMeta);
                const existingRootFilter = existingRootFilters[1] || existingRootFilters[0];
                if (existingRootFilter) {
                    if ('group_operator' in groupOrFilter && existingRootFilter.logical_op !== extractLogicalOp(groupOrFilter.group_operator)) {
                        var _existingRootFilter_logical_op;
                        _catchError.NcError.get(context).badRequest(`A root group with a different group operator already exists. Existing: ${(_existingRootFilter_logical_op = existingRootFilter.logical_op) == null ? void 0 : _existingRootFilter_logical_op.toUpperCase()}, New: ${groupOrFilter.group_operator}`);
                    } else if (!('group_operator' in groupOrFilter)) {
                        _catchError.NcError.get(context).badRequest(`A root group already exists. Cannot add a standalone filter to the root.`);
                    }
                }
                currentParentId = null;
            } else {
                // Insert root group
                const rootGroupResponse = await _models.Filter.insert(context, _extends({
                    is_group: true,
                    fk_parent_id: null,
                    logical_op: extractLogicalOp(logicalOp)
                }, additionalProps, {
                    id: undefined
                }), ncMeta);
                currentParentId = rootGroupResponse.id;
            }
        } else if (parentId === 'root') {
            currentParentId = null;
        } else {
            // Insert root group
            const rootGroupResponse = await _models.Filter.insert(context, _extends({
                is_group: true,
                fk_parent_id: parentId,
                logical_op: extractLogicalOp(logicalOp)
            }, additionalProps, {
                id: undefined
            }), ncMeta);
            currentParentId = rootGroupResponse.id;
        }
        if ('group_operator' in groupOrFilter) {
            // Handle nested groups and filters recursively
            for (const child of groupOrFilter.filters || []){
                if ('field_id' in child) {
                    // Insert individual filter
                    await _models.Filter.insert(context, _extends({}, (0, _apiv3datatransformationbuilder.filterRevBuilder)().build(child), {
                        fk_parent_id: currentParentId,
                        logical_op: extractLogicalOp(groupOrFilter.group_operator) || 'and'
                    }, additionalProps, {
                        id: undefined
                    }), ncMeta);
                } else if ('group_operator' in child) {
                    // Recursively handle nested groups
                    await this.insertFilterGroup({
                        context,
                        param,
                        groupOrFilter: child,
                        parentId: currentParentId,
                        logicalOp: groupOrFilter.group_operator,
                        isRoot: false,
                        viewId,
                        viewWebhookManager,
                        ncMeta
                    });
                }
            }
        } else if ('field_id' in groupOrFilter) {
            // Handle a single filter directly
            await _models.Filter.insert(context, _extends({}, groupOrFilter, {
                fk_parent_id: currentParentId,
                logical_op: extractLogicalOp(logicalOp)
            }, additionalProps, {
                id: undefined
            }), ncMeta);
        } else {
            _catchError.NcError.get(context).badRequest('Invalid structure: Expected a group or filter.');
        }
        if (innerViewWebhookManager) {
            (await innerViewWebhookManager.withNewViewId(innerViewWebhookManager.getViewId())).emit();
        }
    }
    async extractAdditionalProps(param, context, ncMeta) {
        let additionalProps = {};
        let additionalAuditProps = {};
        if ('hookId' in param && param.hookId) {
            const hook = await _models.Hook.get(context, param.hookId);
            if (!hook) {
                _catchError.NcError.hookNotFound(param.hookId);
            }
            additionalProps = {
                fk_hook_id: param.hookId
            };
            additionalAuditProps = {
                hook
            };
        } else if ('rowColorConditionId' in param && param.rowColorConditionId) {
            const rowColorCondition = await _RowColorCondition.default.getById(context, param.rowColorConditionId, ncMeta);
            if (!rowColorCondition) {
                _catchError.NcError.get(context).invalidRequestBody(`Row color condition with id ${param.rowColorConditionId} not found`);
            }
            additionalProps = {
                fk_row_color_condition_id: param.rowColorConditionId
            };
            additionalAuditProps = {
                rowColorCondition
            };
        } else if ('viewId' in param && param.viewId) {
            const view = await _models.View.get(context, param.viewId);
            if (!view) {
                _catchError.NcError.viewNotFound(param.viewId);
            }
            additionalProps = {
                fk_view_id: param.viewId
            };
            additionalAuditProps = {
                view
            };
        }
        return {
            additionalProps,
            additionalAuditProps
        };
    }
    async filterDelete(context, param) {
        var _param_filterId;
        // if filter id is `root` then delete whole filters of the view
        if (param.filterId === 'root') {
            await _models.Filter.deleteAll(context, param.viewId);
            return {};
        }
        // confirm if filter belongs to view
        const filter = await _models.Filter.get(context, (_param_filterId = param.filterId) != null ? _param_filterId : '');
        if (!filter || filter.fk_view_id !== param.viewId) {
            _catchError.NcError.badRequest('Filter not found');
        }
        await this.filtersService.filterDelete(context, param);
        return {};
    }
    async filterUpdate(context, param) {
        var _param_filterId;
        (0, _helpers.validatePayload)('swagger-v3.json#/components/schemas/FilterUpdate', param.filter, true);
        const filter = await _models.Filter.get(context, (_param_filterId = param.filterId) != null ? _param_filterId : '');
        if (!filter) {
            _catchError.NcError.badRequest('Filter not found');
        }
        // if group operator is changed, update all children logical_op
        if (filter.is_group) {
            if (param.filter.group_operator) {
                await _models.Filter.updateAllChildrenLogicalOp(context, {
                    viewId: param.viewId,
                    parentFilterId: param.filterId,
                    logicalOp: extractLogicalOp(param.filter.group_operator)
                });
            }
        } else {
            const remappedFilter = (0, _apiv3datatransformationbuilder.filterRevBuilder)().build(param.filter);
            delete remappedFilter.logical_op;
            await this.filtersService.filterUpdate(context, {
                filterId: param.filterId,
                filter: remappedFilter,
                user: param.user,
                req: param.req
            });
        }
        // if (filter.is_group) {
        //   return await this.extractGroup(context, {
        //     viewId: param.viewId,
        //     parentFilterId: param.filterId,
        //   });
        // }
        return this.filterList(context, {
            viewId: param.viewId
        });
    }
    async extractGroup(context, param, ncMeta = _Noco.default.ncMeta) {
        // get nested list
        const list = await this.filterList(context, {
            viewId: param.viewId
        }, ncMeta);
        if (param.parentFilterId === 'root') {
            return list;
        }
        // iterate recursively and extract filter and return
        const extractFilter = (list)=>{
            for (const item of list){
                if (item.id === param.parentFilterId) {
                    return item;
                }
                if (item.filters) {
                    const filter = extractFilter(item.filters);
                    if (filter) {
                        return filter;
                    }
                }
            }
        };
        return extractFilter(list == null ? void 0 : list.filters);
    }
    async filterList(context, param, ncMeta = _Noco.default.ncMeta) {
        let filters = [];
        if ('hookId' in param && param.hookId) {
            filters = await _models.Filter.allHookFilterList(context, {
                hookId: param.hookId
            }, ncMeta);
        } else if ('linkColumnId' in param && param.linkColumnId) {
            filters = await _models.Filter.allLinkFilterList(context, {
                linkColumnId: param.linkColumnId
            }, ncMeta);
        } else if ('viewId' in param && param.viewId) {
            filters = await _models.Filter.allViewFilterList(context, {
                viewId: param.viewId
            }, ncMeta);
        }
        return addDummyRootAndNest((0, _apiv3datatransformationbuilder.filterBuilder)().build(filters));
    }
    async filterReplace(context, param) {
        // delete existing filters
        await _models.Filter.deleteAll(context, param.viewId);
        // then create filters using filterCreate
        return this.filterCreate(context, _extends({
            filter: param.filter,
            user: param.user,
            req: param.req
        }, param));
    }
    // skip viewWebhookManager for this, deleteAll is not a standalone operation, it's invoked by view service
    async filterDeleteAll(context, param, ncMeta) {
        return _models.Filter.deleteAll(context, param.viewId, ncMeta);
    }
    constructor(appHooksService, filtersService){
        this.appHooksService = appHooksService;
        this.filtersService = filtersService;
    }
};
FiltersV3Service = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService,
        typeof _filtersservice.FiltersService === "undefined" ? Object : _filtersservice.FiltersService
    ])
], FiltersV3Service);
